import {combine} from 'effector';
import {createGate} from 'effector-react';

import {fetchOrganizationList} from 'api/organizations';
import {createTableModel} from 'core/hooks/table';
import {rootDomain} from 'core/rootDomain';
import {BillingBalance} from 'types/billing';
import {OrganizationPaginationContent} from 'types/profile';

const domain = rootDomain.createDomain('organizationTableDomain');

export const Gate = createGate('OrganizationTableGate');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchOrganizationList,
});

export const organizationBalanceChanged = domain.createEvent<BillingBalance>();

export const {
    filters$,
    filtersChanged,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
} = createTableModel({
    domain,
});

export const organizationList$ = domain.createStore<OrganizationPaginationContent | null>(null);

export const organizationState$ = combine({
    data: organizationList$,
    filters: filters$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    isLoading: fetchDataFx.pending,
});
